import React, { useState } from 'react';
import SecondaryButton from '../../button/SecondaryButton';
import './SidebarNav.css';

/**
 * SidebarNav Component
 * Sidebar navigation component using Button sub-components
 * 
 * @param {Array} items - Array of nav items or grouped structure {id: string, title?: string, items: Array}
 * @param {string} activePath - Currently active path/route
 * @param {function} onNavigate - Callback when navigation item clicked: (path: string) => void
 * @param {boolean} grouped - Boolean for grouped navigation (default: false)
 * @param {string} className - Additional CSS classes
 */
const SidebarNav = ({
  items = [],
  activePath,
  onNavigate,
  grouped = false,
  className = ''
}) => {
  const [expandedGroups, setExpandedGroups] = useState({});

  const handleItemClick = (item) => {
    if (onNavigate && item.path) {
      onNavigate(item.path);
    }
  };

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const isActive = (path) => {
    if (!activePath || !path) return false;
    return activePath === path || activePath.startsWith(path + '/');
  };

  if (grouped) {
    // Grouped navigation structure
    return (
      <nav className={`sidebar-nav sidebar-nav-grouped ${className}`.trim()}>
        <ul className="sidebar-nav-list">
          {items.map((group) => {
            const isExpanded = expandedGroups[group.id];
            const hasItems = group.items && group.items.length > 0;
            
            return (
              <li key={group.id} className="sidebar-nav-group">
                {group.title && (
                  <SecondaryButton
                    variant="outline"
                    size="small"
                    onClick={() => hasItems && toggleGroup(group.id)}
                    className={`sidebar-nav-group-header ${hasItems ? 'expandable' : ''} ${isExpanded ? 'expanded' : ''}`.trim()}
                  >
                    <span className="sidebar-nav-group-title">{group.title}</span>
                    {hasItems && (
                      <span className="sidebar-nav-group-arrow">
                        {isExpanded ? '▼' : '▶'}
                      </span>
                    )}
                  </SecondaryButton>
                )}
                {hasItems && isExpanded && (
                  <ul className="sidebar-nav-group-items">
                    {group.items.map((item, index) => {
                      const itemActive = isActive(item.path);
                      return (
                        <li key={index} className="sidebar-nav-group-item">
                          <SecondaryButton
                            variant="outline"
                            size="small"
                            onClick={() => handleItemClick(item)}
                            className={`sidebar-nav-item ${itemActive ? 'active' : ''}`.trim()}
                          >
                            {item.label}
                          </SecondaryButton>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }

  // Flat navigation structure
  return (
    <nav className={`sidebar-nav sidebar-nav-flat ${className}`.trim()}>
      <ul className="sidebar-nav-list">
        {items.map((item, index) => {
          const itemActive = isActive(item.path || item.id);
          return (
            <li key={item.id || index} className="sidebar-nav-item-wrapper">
              <SecondaryButton
                variant="outline"
                size="small"
                onClick={() => handleItemClick(item)}
                className={`sidebar-nav-item ${itemActive ? 'active' : ''}`.trim()}
              >
                {item.label}
              </SecondaryButton>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default SidebarNav;










